import request from '@/utils/request'

export interface IContract {
  id?: number
  contractName: string
  version: string
  isActive: boolean
  localizationKey: string
  description?: string
  createdAt?: string
  updatedAt?: string
  acceptanceCount?: number
}

export interface IContractStatistics {
  totalContracts: number
  activeContracts: number
  totalAcceptances: number
  acceptanceBreakdown: Array<{
    contractName: string
    version: string
    isActive: boolean
    acceptanceCount: number
  }>
}

export interface ICreateContractRequest {
  contractName: string
  version: string
  localizationKey: string
  description?: string
  deactivateOldVersions?: boolean
}

export interface IUpdateContractRequest {
  localizationKey?: string
  description?: string
}

export interface IToggleContractRequest {
  isActive: boolean
}

/**
 * Get all contracts with optional filters
 */
export const getAllContracts = (params?: {
  contractName?: string
  isActive?: boolean
}) =>
  request({
    url: '/admin/contracts',
    method: 'get',
    params
  })

/**
 * Get contract statistics
 */
export const getContractStatistics = () =>
  request({
    url: '/admin/contracts/statistics',
    method: 'get'
  })

/**
 * Get specific contract by ID
 */
export const getContractById = (id: number) =>
  request({
    url: `/admin/contracts/${id}`,
    method: 'get'
  })

/**
 * Create new contract version
 */
export const createContractVersion = (data: ICreateContractRequest) =>
  request({
    url: '/admin/contracts',
    method: 'post',
    data
  })

/**
 * Update contract (description, localization_key only)
 */
export const updateContract = (id: number, data: IUpdateContractRequest) =>
  request({
    url: `/admin/contracts/${id}`,
    method: 'put',
    data
  })

/**
 * Toggle contract active status
 */
export const toggleContractStatus = (id: number, data: IToggleContractRequest) =>
  request({
    url: `/admin/contracts/${id}/toggle`,
    method: 'post',
    data
  })

/**
 * Delete contract (only if no user acceptances)
 */
export const deleteContract = (id: number) =>
  request({
    url: `/admin/contracts/${id}`,
    method: 'delete'
  })
